import { useMutation } from '@apollo/client';
import mutation from 'client/mutations/convertPreorder';

export default function useConvertPreorder() {
  return useMutation(mutation);
}
